import { IconHelp } from "@studyplus/boron-ui";
import classNames from "classnames";

type Props = {
  helpUrl?: string;
  isOnlyLearningManagementStudent: boolean;
  noteText?: string;
  className?: string;
};

export const MultiSectionBatchesDescription = ({
  helpUrl,
  isOnlyLearningManagementStudent,
  noteText,
  className,
}: Props) => {
  const displayNote =
    noteText ??
    (isOnlyLearningManagementStudent
      ? "※学習管理サービスの生徒のみが出力されます。"
      : undefined);

  return (
    <div className={classNames("mb-10 mt-8", className)}>
      {helpUrl && (
        <p className="flex items-center flex-wrap">
          操作方法を確認しながら進めてください。
          <a
            href={helpUrl}
            rel="noopener noreferrer"
            target="_blank"
            className="flex items-center text-blue-400 hover:text-blue-300"
          >
            <IconHelp />
            操作方法を見る
          </a>
        </p>
      )}
      <p
        className={classNames("text-gray-800 text-sm", {
          invisible: !displayNote,
        })}
      >
        {displayNote ?? "※学習管理サービスの生徒のみが出力されます。"}
      </p>
    </div>
  );
};
